import { Flex, TextButton, IconV2 } from '@bamboohr/fabric';
import {
       Message,
} from '@bamboohr/utils/lib/message';

type StateWHMigrationMessageProps = {
	onMigrateFormClick: () => void;
	/** The two-letter shorthand of a US State */
	stateAbbreviation: string;
}

const stateMessage = new Map<string, string>([
	['IA', $.__('Need to make changes? [Update using the new Iowa State form.]')],
	['LA', $.__('The Louisiana State Tax Withholding Form has changed. [Make changes with the updated form fields.]')],
]);

export function StateWHMigrationMessage({
	onMigrateFormClick,
	stateAbbreviation
}: StateWHMigrationMessageProps) {

	const handleMigrationFormClick = () => {
		onMigrateFormClick()
	}

	return (
		stateAbbreviation 
		? <Flex
			alignItems="center"
			flexWrap="wrap"
			gap="6px"
		>
			<IconV2
				color='neutral-extra-strong'
				name='circle-info-regular'
				size={16}
			/>
			<Message
				link={(text) => (
					<TextButton
						data-bi-id="payinfo-taxes-statewh-updatedform-link"
						inline={true}
						onClick={handleMigrationFormClick}
						type='button'
					>
						{text}
					</TextButton>
				)}
				text={ stateMessage.get(stateAbbreviation) }
			/>
		</Flex>
		: null
	);
}